import { render } from "./PreviewMembershipPortfolios.vue?vue&type=template&id=06f61d19&scoped=true"
import script from "./PreviewMembershipPortfolios.vue?vue&type=script&lang=js"
export * from "./PreviewMembershipPortfolios.vue?vue&type=script&lang=js"

import "./PreviewMembershipPortfolios.vue?vue&type=style&index=0&id=06f61d19&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/sharesight_partner_app/sharesight_partner_app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f61d19"]])

export default __exports__